import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Tue Oct 30 2018
 * @author Tomáš Leity
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { WindowType } from '@logio/common-be-fe';
import { action, observable, runInAction } from 'mobx';
import { WindowTypeLayer } from '../../transportLayers/promo-settings/WindowTypeLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
import { Map } from 'immutable';
/**
 * Persistent store for WindowType
 */

export var WindowTypeStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(WindowTypeStore, _BaseStore);

  function WindowTypeStore() {
    var _this;

    _classCallCheck(this, WindowTypeStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowTypeStore).apply(this, arguments));
    /** Store name */

    _this.name = StoreName.WindowType;
    /** Layer contains methods for fetching data */

    _this.windowTypeLayer = new WindowTypeLayer();
    /** List of WindowTypes */

    _this.list = Map();
    /**
     * Fetches all WindowTypes
     * @returns a promise with Map of all WindowTypes
     */

    _this.getAll = function () {
      return _this.windowTypeLayer.findAll().then(function (windowTypes) {
        _this.list = _this.list.clear();
        runInAction(function () {
          windowTypes.forEach(function (windowType) {
            _this.list = _this.list.set(windowType.id, windowType);
          });
        });
        return _this.list;
      });
    };
    /**
     * Fetches one WindowType
     * @returns a promise with WindowType
     * @param id
     */


    _this.getOne = function (id) {
      return _this.windowTypeLayer.findOne(id).then(function (windowType) {
        runInAction(function () {
          _this.list = _this.list.set(windowType.id, windowType);
        });
        return windowType;
      });
    };
    /**
     * Updates WindowType using WindowTypeLayer
     * @param windowType - WindowType that you want to update
     */


    _this.update = function (windowType) {
      return _this.windowTypeLayer.update(windowType).then(function (retWindowType) {
        runInAction(function () {
          _this.list = _this.list.set(retWindowType.id, retWindowType);
        });
      });
    };
    /**
     * Creates new WindowType using WindowTypeLayer
     * @param windowType - new WindowType that you want to create
     */


    _this.create = function (windowType) {
      return _this.windowTypeLayer.create(windowType).then(function (awindowType) {
        runInAction(function () {
          _this.list = _this.list.set(awindowType.id, awindowType);
        });
      });
    };
    /**
     * Blocks/Un-blocks WindowType
     * @param windowType - WindowType schema
     */


    _this.block = function (windowType) {
      return _this.windowTypeLayer.block(windowType).then(function (awindowType) {
        runInAction(function () {
          _this.list = _this.list.set(awindowType.id, awindowType);
        });
      });
    };
    /**
     * Deletes WindowType using WindowTypeLayer
     * @param id - id of the WindowType you want to delete.
     */


    _this.delete = function (id) {
      return _this.windowTypeLayer.delete(id).then(function () {
        runInAction(function () {
          _this.list = _this.list.delete(id);
        });
        return _this.list;
      });
    };

    return _this;
  }
  /**
   * Fetches one WindowType
   * @param id
   * @returns a promise with WindowType
   */


  _createClass(WindowTypeStore, [{
    key: "getWindowTypeDetail",
    value: function getWindowTypeDetail(id) {
      var _this2 = this;

      return this.windowTypeLayer.findOne(id).then(function (windowType) {
        runInAction(function () {
          _this2.detail = windowType;
        });
        return windowType;
      });
    }
  }]);

  return WindowTypeStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", WindowType)], WindowTypeStore.prototype, "detail", void 0);

__decorate([observable, __metadata("design:type", Object)], WindowTypeStore.prototype, "list", void 0);

__decorate([action.bound, __metadata("design:type", Function), __metadata("design:paramtypes", [String]), __metadata("design:returntype", Promise)], WindowTypeStore.prototype, "getWindowTypeDetail", null);

__decorate([action, __metadata("design:type", Object)], WindowTypeStore.prototype, "getAll", void 0);

__decorate([action, __metadata("design:type", Object)], WindowTypeStore.prototype, "getOne", void 0);

__decorate([action, __metadata("design:type", Object)], WindowTypeStore.prototype, "update", void 0);

__decorate([action, __metadata("design:type", Object)], WindowTypeStore.prototype, "create", void 0);

__decorate([action, __metadata("design:type", Object)], WindowTypeStore.prototype, "block", void 0);

__decorate([action, __metadata("design:type", Object)], WindowTypeStore.prototype, "delete", void 0);